import { z } from 'zod'

const amountSchema = z
  .string()
  .trim()
  .regex(/^[+-]?\d+(?:\.\d+)?$/, 'Enter a decimal amount')
  .refine((value) => {
    const [integer, fraction = ''] = value.replace(/^[+-]/, '').split('.')
    return integer.replace(/^0+/, '').length <= 18 && fraction.length <= 10
  }, 'Maximum 18 integer and 10 decimal places')

const notesSchema = z.string().trim().min(11, 'Enter at least 11 characters').max(200, 'Maximum 200 characters')

export const dailyCorrectionSchema = z.object({ amount: amountSchema, notes: notesSchema })
export type DailyCorrectionValues = z.infer<typeof dailyCorrectionSchema>

export const balanceCorrectionSchema = z.object({
  opening_balance_local: amountSchema,
  accrued_balance_local: amountSchema,
  notes: notesSchema,
})
export type BalanceCorrectionValues = z.infer<typeof balanceCorrectionSchema>
